import SyncRoundedIcon from '@mui/icons-material/SyncRounded';
import { Box, Stack, Button, Typography } from '@mui/material';
import CloudOffRoundedIcon from '@mui/icons-material/CloudOffRounded';

import MuiIcon from 'src/components/mui-icon';

import { useConnectivityStore } from './connectivity-store';
import { connectivityCoordinator } from './connectivity-service';

export function OfflineModeIndicator() {
  const isOfflineMode = useConnectivityStore((state) => state.runtimeState === 'OFFLINE_MODE');

  if (!isOfflineMode) return null;

  return (
    <Box
      role="status"
      sx={{
        position: 'fixed',
        zIndex: (theme) => theme.zIndex.snackbar,
        right: { xs: 12, sm: 24 },
        bottom: { xs: 'calc(env(safe-area-inset-bottom) + 12px)', sm: 24 },
        left: { xs: 12, sm: 'auto' },
        px: 1.5,
        py: 1,
        borderRadius: 2,
        bgcolor: '#172235',
        color: 'common.white',
        boxShadow: '0 16px 44px rgba(15, 23, 42, 0.28)',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.25}>
        <MuiIcon icon={CloudOffRoundedIcon} width={20} />
        <Box sx={{ flex: 1 }}>
          <Typography variant="subtitle2" color="inherit">
            Offline mode
          </Typography>
          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.72)' }}>
            Sales apps are available; transaction requirements still apply
          </Typography>
        </Box>
        <Button
          size="small"
          color="inherit"
          variant="outlined"
          startIcon={<MuiIcon icon={SyncRoundedIcon} width={17} />}
          onClick={() => connectivityCoordinator.leaveOfflineMode().catch(() => undefined)}
          sx={{ borderColor: 'rgba(255,255,255,0.32)', whiteSpace: 'nowrap' }}
        >
          Go online
        </Button>
      </Stack>
    </Box>
  );
}
